import { IonIcon, IonItem, IonList, IonText } from '@ionic/react';
import { informationCircleOutline } from 'ionicons/icons';
import { Device } from 'util/device';
import Trans from 'util/Trans';
import './PopUpMenu.css';

interface OptionsProps {
  isFavorite: boolean;
  hasVideo: boolean;
  onStar: () => void;
  onHide: () => void;
  onDelete: () => void;
  onInfo: () => void;
  onShare: () => void;
  onVideoRender: () => void;
  onEditMode: () => void;
  renderProgress: number | null;
}

const PopUpMenu: React.FC<OptionsProps> = ({
  isFavorite,
  hasVideo,
  onStar,
  onShare,
  onVideoRender,
  onInfo,
  renderProgress,
}) => {
  const hasRendering = Device.platform === 'ios';
  return (
    <div className="popup-menu-container">
      <IonList className="popup-menu" lines="none">
        {/* TRICK INFO */}
        <IonItem detail={false} button onClick={onInfo}>
          <IonIcon icon={informationCircleOutline} color="secondary" />
          <div style={{ width: '1rem' }} />
          <IonText style={{ color: 'var(--ion-text-color)' }}>
            <Trans i18nKey="TRICK_INFO">Trick Info</Trans>
          </IonText>
        </IonItem>

        {/* SHARE */}
        <IonItem detail={false} button onClick={onShare}>
          <IonIcon src="/assets/icons/Share.svg" color="secondary" />
          <div style={{ width: '1rem' }} />
          <IonText style={{ color: 'var(--ion-text-color)' }}>
            <Trans i18nKey="SHARE">Teilen</Trans>
          </IonText>
        </IonItem>
        {hasVideo && (
          <IonItem
            detail={false}
            button
            onClick={hasRendering ? onVideoRender : undefined}
          >
            {!hasRendering && (
              <div id="pop-up-menu-overlay">
                <span>
                  <b>Coming Soon</b>
                </span>
              </div>
            )}
            <IonIcon src="/assets/icons/Share_Video.svg" color="secondary" />
            <div style={{ width: '1rem' }} />
            <IonText style={{ color: 'var(--ion-text-color)' }}>
              <Trans i18nKey="SHARE_VIDEO">Video Teilen</Trans>
            </IonText>
            {renderProgress && (
              <IonText
                style={{ paddingLeft: '8px', color: 'var(--ion-text-color)' }}
              >{`${renderProgress}%`}</IonText>
            )}
          </IonItem>
        )}
        {/* FAVORIT */}
        <IonItem detail={false} button onClick={onStar}>
          <IonIcon
            src={`/assets/icons/star${isFavorite ? '_filled' : ''}.svg`}
            color="secondary"
          />
          <div style={{ width: '1rem' }} />
          <IonText style={{ color: 'var(--ion-text-color)' }}>
            <Trans i18nKey="FAVORIT">Favorit</Trans>
          </IonText>
        </IonItem>
      </IonList>
    </div>
  );
};

export default PopUpMenu;
